@if (fields && fields.hasOwnProperty('blocks') && fields.blocks.length>0 && config != undefined && config.filterLabel == undefined) {
  @if (persistValue!=undefined && !persistValue.hideUgfilter && persistValue.save_filter && rolePermissionService.checkAccessPermission('user_group_filter','user_group_filter','account-management')) {
    <span (mouseenter)="isUserGroupTooltipOpen = true; isSaveTooltipOpen = false" (mouseleave)="isUserGroupTooltipOpen = false">
      @if (!isUserGroupTooltipOpen) {
        <a class="filter-save-icon-ug" href="javascript:void(0)"
          (click)="$event.stopPropagation(); saveFilter(false,true,true)">
          <i class="fa fa-users save-btn-filter"></i>
        </a>
      }
      @if (isUserGroupTooltipOpen) {
        <a [popover]="popTemplateUG" placement="top" container="body" containerClass="info-popover"
          class="filter-save-icon-ug" href="javascript:void(0)"
          [isOpen]="true"
          (onHidden)="isUserGroupTooltipOpen = false"
          (click)="$event.stopPropagation(); saveFilter(false,true,true)">
          <i class="fa fa-users save-btn-filter"></i>
        </a>
        <ng-template #popTemplateUG>
          Save Filter As Per User Group
        </ng-template>
      }
    </span>
  }
  @if (persistValue && persistValue.save_filter) {
    <span (mouseenter)="isSaveTooltipOpen = true; isUserGroupTooltipOpen = false" (mouseleave)="isSaveTooltipOpen = false">
      @if (!isSaveTooltipOpen) {
        <a class="filter-save-icon" href="javascript:void(0)"
          (click)="$event.stopPropagation(); saveFilter()">
          <!-- <i class="fa fa-floppy-o save-btn-filter"></i> -->
          <img class="save-btn-filter-i" src="assets/images/btn-icons/platform icons_button-save.svg">
        </a>
      }
      @if (isSaveTooltipOpen) {
        <a [popover]="popTemplate" placement="top" container="body" containerClass="info-popover"
          class="filter-save-icon" href="javascript:void(0)"
          [isOpen]="true"
          (onHidden)="isSaveTooltipOpen = false"
          (click)="$event.stopPropagation(); saveFilter()">
          <!-- <i class="fa fa-floppy-o save-btn-filter"></i> -->
          <img class="save-btn-filter-i" src="assets/images/btn-icons/platform icons_button-save.svg">
        </a>
        <ng-template #popTemplate>
          {{'Save Filter' | translate | async}}
        </ng-template>
      }
    </span>
  }
  @if ((persistValue!=undefined && !persistValue.hideSaveAs) && config.currentFilter != undefined && persistValue && persistValue.save_filter) {
    <a href="javascript:void(0)"
    class="save-as-filter-link" (click)="saveFilter(true)">SaveAs</a>
  }
  <!-- <b  class="pull-right mr-5 mt-1" href="javascript:void(0)">{{config.currentFilterName}}</b> -->
  <dhs-form [fieldGroup]="fields" [config]="fiterConfig" [data]="filterData" (saveFinished)="doSearch($event)"
    (getData)="getDataFn($event)" (resetForm)="resetFormClick($event)" [action]="'SEARCH'" [decorator]="decorator"
    #form>
  </dhs-form>
}
@if (config.filterLabel != undefined) {
  @for (item of config.filterLabel | keys; track item) {
    <div class="d-flex p-1 pl-2">
      <div class="filter-label" style="font-weight: bold">{{item}} : </div>
      <div class="filter-value"> &nbsp;&nbsp;{{config.filterLabel[item]}}</div>
    </div>
  }
  <div class="row form-primary-actions sticky-add-btn mt-3">
    <div class="col-6 text-right">
      <button type="button" (click)="resetFormClick(true)"  class="secondary-btn">
        {{'button.clear' | translate | async}}
        <i aria-hidden="true" class="fa fa-times-circle ml-2"></i>
      </button>
    </div>
  </div>
}
